const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.card.background,
    height: '100%',
    borderRadius: '20px',
  },
})

export default styles
